export function buildPdfFilename(nf) {
  const digits = String(nf.numero || nf.nfID).replace(/\D+/g, '') || '0'
  const number = digits.padStart(5, '0')
  const clientName = Array.from(String(nf.clienteNome || 'Cliente'))
    .map((character) => character.charCodeAt(0) < 32 ? '-' : character)
    .join('')
    .trim()
    .replace(/[<>:"/\\|?*]+/g, '-')
    .replace(/\s+/g, ' ')
    .replace(/^[ .-]+|[ .-]+$/g, '') || 'Cliente'

  return `NF-${number} - ${clientName}.pdf`
}

export function openPdfUrl(url, openWindow = window.open) {
  return openWindow(url, '_blank', 'noopener,noreferrer')
}

export function downloadPdfUrl(url, nf, createAnchor = () => document.createElement('a')) {
  const anchor = createAnchor()
  anchor.href = url
  anchor.download = buildPdfFilename(nf)
  anchor.click()
}
